import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/programming-language-kotlin.svg?component
var programming_language_kotlin_exports = /* @__PURE__ */ __exportAll({
	default: () => programming_language_kotlin_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 128 128"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M0 0h61.4L0 60.4zm0 128L128 0H64.6L0 63.7zm128 0L64.6 66.6 3.3 128z" }, null, -1)])]);
}
var programming_language_kotlin_default = { render: render$1 };
//#endregion
export { programming_language_kotlin_default as default, programming_language_kotlin_exports, render$1 as render };

//# sourceMappingURL=programming-language-kotlin.svg_component.js.map